import React, { useState, useEffect } from 'react'
import api from '../../components/api'

import { useGeradoresEstacionariosContext } from '../../context/geradoresEstacionariosContext'


import { useTabelaGestao } from '../../context/GestaoPendenciasContext'

import Table from 'react-bootstrap/Table'


import { Link } from 'react-router-dom'
import { useEnunciadoContext } from '../../context/enunciadoContext'
import { useVerificaDesafioContext } from '../../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../../context/secaoEnunciadoContext'
import { LabelImportant } from '@mui/icons-material'

import StatusValidacaoSecao from '../StatusValidacaoSecao';


const Geradores = (props) => {


    var ano = props.ano
    var energia_id = props.energia_id

    const { atualizacaoGestao } = useTabelaGestao()


    const { energiaGerador_id, setEnergiaGerador_id } = useGeradoresEstacionariosContext()
    const [resultadoGeradores, setResultadoGeradores] = useState()

    const [informa, setInforma] = useState(true)


    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()




    const [questao1, setQuestao1] = useState()
    const [totalPendencias, setTotalPendencias] = useState(0)
    



    useEffect(() => {

        verificaValidacoes()

    }, [energia_id, verificaDesafio])


    const verificaValidacoes = () => {

        //console.log('verificado')

        setQuestao1()
        
        

        if (energia_id) {

            var dataPost = {

                formulario_id: energia_id,
                desafio: 'Energia',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                //console.log(data)
                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case 'Geradores Estacionários':

                                totalErros = totalErros + 1
                                setQuestao1('red')
    
                            break

                        }

                    }

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }

    


    const consultaGeradores = () => {

        api.get(`energiaGeradorListaTodos/${energia_id}`).then((result) => {

            console.log(result.data)
            setResultadoGeradores(result.data.map((rs) =>
            
                <tr style={{ cursor: 'pointer'}} onClick={() => {window.$('#modalGeradorEstacionario').modal('show');setEnergiaGerador_id(rs.energiaGerador_id)}}>
                    <td>
                        {rs.descricao}
                    </td>
                    <td>
                        <center>
                        {rs.anoFabricacao}
                        </center>
                    </td>
                    <td>
                        <center>
                        {rs.quantidade}
                        </center>
                    </td>
                </tr>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }


    const consultaInforma = () => {

        api.get(`energiaInforma/${energia_id}/informaGeradores`).then((result) => {

            //console.log(result.data)
            setInforma(result.data[0].informaGeradores)

        }).catch((err) => {

            console.log(err.response)

        })
    }



    useEffect(() => {

        var dataPost = {

            tipo: 'informaGeradores',
            informa: informa,

        }

        api.post(`energiaInforma/${energia_id}`, dataPost).then((result) => {

            console.log(result.data)

        }).catch((err) => {

            console.log(err.response)

        })

    }, [informa])



    useEffect(() => {

        
        consultaGeradores()
        consultaInforma()
        
    }, [ano, energia_id, atualizacaoGestao])




    return (
        <div>



            <div className="col-md-12">
                <div align="left">

                
                    <select className="form-control" value={informa} onChange={event => setInforma(event.target.value)}>
                        <option value={true}>A instituição possui o(s) equipamento(s) e reportará suas informações</option>
                        <option value={false}>A instituição não possui o(s) equipamento(s) ou a instituição possui o(s) equipamento(s) mas não reportará suas informações</option>
                    </select>
                    <br/>

                </div>
            </div>


            <div className="col-md-12"  style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>
                <div align="left">

                    <Link to='#' style={{ color: questao1 }} onClick={() => {setEnunciado('Geradores Estacionários');setSecaoEnunciado('Geradores Estacionários');window.$('#modalValidacao').modal('show')}}>
                    [Informar Não Conformidade]</Link>
                    <br/><br/>
                    
                    
                    <button type="button" className="btn btn-warning" onClick={() => {window.$('#modalGeradorEstacionario').modal('show');setEnergiaGerador_id()}}  >+ Adicionar Gerador</button>
                    <br/><br/>

                </div>
            </div>


            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>


                <Table striped bordered hover>

                    <thead>
                        
                        <tr>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Tipo

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>
                                <center>
                                Ano de Fabricação
                                </center>

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>
                                <center>
                                Quantidade
                                </center>

                            </th>
                            
                           

                        </tr>
                    </thead>
                    <tbody>
                        {resultadoGeradores}
                    </tbody>

                </Table>

            </div>



            <StatusValidacaoSecao desafio="Energia" secaoCampo="secaoGeradores" totalPendencias={totalPendencias} nomeDesafio="Desafio Energia" formulario_id={energia_id} secao="Geradores Estacionários" ano={ano} />




        </div>
    )


}

export default Geradores